import React from 'react';
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {enableAllPlugins} from 'immer';
import { createTheme, CssBaseline, ThemeProvider, responsiveFontSizes } from '@mui/material';
import store from './state';
import initFirebase from './firebase';
import HomePage from './pages/home/HomePage';
import MapPage from './pages/map/MapPage'
import PintPage from './pages/redeem/PintPage'
import PrizePage from './pages/redeem/PrizePage'

// initialize immer
enableAllPlugins();

// initialize firebase
initFirebase(store);

// initialize mui theme
const theme = responsiveFontSizes(createTheme({
  typography: {
    fontFamily: `"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif`,
    body1: {
      fontWeight: 300
    },
    subtitle1: {
      fontWeight: 300,
      fontSize: 18,
      lineHeight: 1.5
    }
  },
  palette: {
    primary: {
      main: '#00C06A',
      contrastText: 'white'
    },
    secondary: {
      main: '#F49013',
      contrastText: 'white'
    },
    tertiary: {
      main: '#5EB3E4',
      contrastText: 'white'
    },
    quaternary: {
      main: '#c03221',
      contrastText: 'white'
    },
    common: {
      black: '#363732'
    },
    background: {
      default: '#f7fafc'
    },
    lightGray: {
      main: '#e7e7e7'
    }
  },
  // shadows: ['none', '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)']
  shadows: [
    'none',
    'rgba(50, 50, 93, 0.024) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)'
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        a: {
          color: '#5EB3E4',
          fontWeight: 600,
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline'
          }
        },
        '.MuiFormHelperText-root': {
          fontWeight: '300 !important',
          fontStyle: 'italic'
        },
        '.MuiButton-root': {
          '&': {
            boxShadow: 'none !important',
            borderRadius: '0 !important'
          }
        }
      }
    }
  }
}));

const App = () => {
  return (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline/>
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/*<Route path="/signup" element={<SignupPage />} />*/}
              {/*<Route path="/signup/:token" element={<RegisterPage />} />*/}
              {/*<Route path="/password/change" element={<PasswordChangePage />} />*/}
              {/*<Route path="/signup/:token" element={<RegisterPage />} />*/}
              {/*<Route path="/app" element={<AppPage />} />*/}
              {/*<Route path="/app/efforts" element={<EffortsPage />} />*/}
              {/*<Route path="/app/leaderboard" element={<LeaderboardPage />} />*/}
              {/*<Route path="/app/membership" element={<MembershipPage />} />*/}
              {/*<Route path="/app/admin" element={<AdminPage />} />*/}
              {/*<Route path="/app/pay" element={<PayPage />} />*/}
              {/*<Route path="/app/strava" element={<StravaAuthPage />} />*/}
              <Route path="/map" element={<MapPage/>} />
              {/*<Route path="/segments" element={<SegmentsPage/>} />*/}
              <Route path="/redeem/:pint" element={<PintPage />} />
              <Route path="/prize/:user/:prize" element={<PrizePage />} />
              {/*<Route path="/redeem/:coupon" element={<RedeemPage />} />*/}
            </Routes>
          </Router>
        </ThemeProvider>
      </Provider>
  )
};
export default App;

